import React from "react";
import { Link } from "react-router-dom";
import guLocale from "../locales/gu";

const Dashboard = ({ totalGrant, usedGrant, remainingGrant, headCount, userCounts, isAdminUser, approvalRequestCount }) => {
  const locale = guLocale.dashboard;
  let dashboardContent;
  if(isAdminUser) {
    dashboardContent = (
      <div className="row">
        <div className="col-lg-3 col-6">
          {/* removed bg-warning */}
          <div className="small-box bg-warning">
            <div className="inner">
              <h3>{userCounts}</h3>
              <p>{locale.users}</p>
            </div>
            <div className="icon">
              <i className="ion ion-person-add custom-ion-icon"/>
            </div>
            <Link to="/admin/users" className="small-box-footer">
              {locale.moreInfo}
              <i className="fas fa-arrow-circle-right" />
            </Link>
          </div>
        </div>
        <div className="col-lg-3 col-6">
          {/* removed bg-info */}
          <div className="small-box bg-info">
            <div className="inner">
              <h3>{approvalRequestCount}</h3>
              <p>{locale.approvalRequests}</p>
            </div>
            <div className="icon">
              <i className="ion ion-clock custom-ion-icon"/>
            </div>
            <Link to="/admin/approval-requests" className="small-box-footer">
              {locale.moreInfo}
              <i className="fas fa-arrow-circle-right" />
            </Link>
          </div>
        </div>
      </div>
    )
  } else {
    dashboardContent = (
      <div className="row">
        <div className="col-lg-3 col-6">
          {/* Remove bg-warning */}
          <div className="small-box bg-warning custom-bg-warning">
            <div className="inner">
              <h3>{headCount}</h3>
              <p>{locale.headRegistrations}</p>
            </div>
            <div className="icon">
              {/* <i className="ion ion-person-add" /> */}
              <i className="fas fa-graduation-cap custom-ion-icon" />
            </div>
            <Link to="/heads" className="small-box-footer">
              {locale.moreInfo}
              <i className="fas fa-arrow-circle-right" />
            </Link>
          </div>
        </div>
        <div className="col-lg-3 col-6">
          {/* Remove bg-success */}
          <div className="small-box bg-success">
            <div className="inner">
              <h3>
                {totalGrant}
                <sup style={{ fontSize: 20 }}></sup>
              </h3>
              <p>{locale.totalGrants}</p>
            </div>
            <div className="icon">
              <i className="ion ion-android-arrow-down custom-ion-icon"/>
            </div>
            <Link to="/ledgers" className="small-box-footer">
              {locale.moreInfo}
              <i className="fas fa-arrow-circle-right" />
            </Link>
          </div>
        </div>
        <div className="col-lg-3 col-6">
          {/* Remove bg-danger */}
          <div className="small-box bg-danger">
            <div className="inner">
              <h3>{usedGrant}</h3>
              <p>{locale.totalUsedGrants}</p>
            </div>
            <div className="icon">
              <i className="ion ion-android-arrow-up custom-ion-icon"/>
            </div>
            <Link to="/ledgers" className="small-box-footer">
              {locale.moreInfo}
              <i className="fas fa-arrow-circle-right" />
            </Link>
          </div>
        </div>
        <div className="col-lg-3 col-6">
          {/* Remove bg-info */}
          <div className="small-box bg-info">
            <div className="inner">
              <h3>{remainingGrant}</h3>
              <p>{locale.totalRemainingGrants}</p>
            </div>
            <div className="icon">
              <i className="ion ion-ios-calculator custom-ion-icon"/>
            </div>
            <Link to="/ledgers" className="small-box-footer">
              {locale.moreInfo}
              <i className="fas fa-arrow-circle-right" />
            </Link>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">{locale.title}</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/">{locale.homeBreadcrumb}</a>
                  </li>
                  <li className="breadcrumb-item active">
                    {locale.dashboardBreadcrumb}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
              {dashboardContent}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Dashboard;
